export default __webpack_public_path__ + "static/media/cedapug_logo.70045b16.png";